module.exports = __webpack_public_path__ + "img/zzh2.c181faa3.jpg";